module.exports = __webpack_public_path__ + "static/media/logo-empx.a18df4f2.png";